export default __webpack_public_path__ + "static/media/workout-timeline-bg.a56716f8.png";